var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3fbc5802\"}!../node_modules/vue-loader/lib/selector?type=template&index=0!./Footer.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/Footer.vue
// module id = 376
// module chunks = 1